import { createContext, useState, useEffect } from "react";
import { useCookies } from "react-cookie";

export const EcommerceContext = createContext();

const EcommerceProvider = ({ children }) => {
  const [shoppingCart, setShoppingCart] = useState([]);

  const [cookies, setCookie] = useCookies(["cart"]);

  useEffect(() => {
    if (cookies.cart) {
      setShoppingCart(cookies.cart);
    } else {
      setShoppingCart([]);
    }
  }, [cookies.cart]);
  
  const addItem = async (product) => {
    if (!(shoppingCart.find((item) => item.product.id === product.id))) {
      let newArr = [...shoppingCart, { product }];
      setShoppingCart(newArr);
      setCookie("cart", newArr, { path: "/" });
    }
  };

  const removeItem = (productId) => {
    if (shoppingCart.length > 0) {
      let newArr = shoppingCart.filter(
        (item) => item.product.id !== productId
      );
      setShoppingCart(newArr);
      setCookie("cart", newArr, { path: "/" });
    }
  };


  return (
    <EcommerceContext.Provider
      value={{
        shoppingCart,
        setShoppingCart,
        setCookie,
        addItem,
        removeItem
      }}
    >
      {children}
    </EcommerceContext.Provider>
  );
};

export default EcommerceProvider;
